import { useLang } from "../i18n";
import { Reveal } from "./Reveal";

export const CTABand = ({ title, text }) => {
  const { data, t } = useLang();
  const { SITE } = data;
  return (
    <section data-testid="cta-band" className="bg-sage text-cream">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
        <Reveal className="md:col-span-7">
          <p className="text-xs uppercase tracking-[0.22em] text-cream/60 mb-5">
            {t.cta.eyebrow}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl leading-tight max-w-xl">
            {title || t.cta.defaultTitle}
          </h2>
        </Reveal>
        <Reveal delay={0.12} className="md:col-span-5">
          <p className="text-sm md:text-base leading-relaxed text-cream/75 max-w-md">
            {text || t.cta.defaultText}
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <a
              href={SITE.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-band-booking-button"
              className="inline-flex items-center rounded-full bg-terra px-7 py-3.5 text-sm font-semibold text-cream transition-[background-color,transform] duration-300 hover:bg-terra-dark hover:-translate-y-0.5"
            >
              {t.cta.book}
            </a>
            <a
              href={SITE.phoneHref}
              data-testid="cta-band-call-button"
              className="inline-flex items-center rounded-full border border-cream/40 px-7 py-3.5 text-sm font-medium text-cream transition-colors duration-300 hover:bg-cream/10"
            >
              {SITE.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
